/** Prefix for user-scoped last Order ID keys — cleared on full logout. */
export const TRACK_YOUR_REMOTE_LAST_ORDER_ID_PREFIX = 'track-your-remote:last-order-id';

/** Prefer stable Heidi user id; never fall back to an unscoped key. */
export const lastOrderIdStorageKey = (
  userId: string | null | undefined
): string | null => {
  const id = userId?.trim();
  if (!id) return null;
  return `${TRACK_YOUR_REMOTE_LAST_ORDER_ID_PREFIX}:${id}`;
};

export const readLastOrderId = (userId: string | null | undefined): string => {
  const key = lastOrderIdStorageKey(userId);
  if (!key || typeof window === 'undefined') return '';
  try {
    return window.localStorage.getItem(key) ?? '';
  } catch {
    return '';
  }
};

export const writeLastOrderId = (
  userId: string | null | undefined,
  orderId: string
): void => {
  const key = lastOrderIdStorageKey(userId);
  if (!key || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(key, orderId);
  } catch {
    // Prefill is best-effort; ignore quota / private-mode failures.
  }
};

/**
 * Drop every Track-your-Remote last-order-id row.
 * Called from `clearLogoutStorage` so a shared workstation cannot leak the
 * departing clinician's Order ID into the next account.
 */
export const clearTrackYourRemoteLastOrderIds = (): void => {
  if (typeof window === 'undefined') return;
  try {
    Object.keys(window.localStorage)
      .filter(
        (key) =>
          key === TRACK_YOUR_REMOTE_LAST_ORDER_ID_PREFIX ||
          key.startsWith(`${TRACK_YOUR_REMOTE_LAST_ORDER_ID_PREFIX}:`)
      )
      .forEach((key) => window.localStorage.removeItem(key));
  } catch {
    // Ignore — restricted webviews may block storage access.
  }
};
